<template>
    <div v-bind:class="readAccessClasses">

        <div class="na-list">
            <DxDataGrid v-model:data-source="topicLinkTypeList"
                        :activeStateEnabled="true"
                        :allowColumnReordering="true"
                        :allowColumnResizing="true"
                        :rowAlternationEnabled="true"
                        @saving="onSaving"
                        @exporting="onExporting"
                        :show-borders="true">
                <DxEditing mode="batch"
                           :allow-updating="true"
                           :allow-adding="false"
                           :allow-deleting="false"
                           startEditAction="click" />
                <DxColumnChooser :enabled="true" />
                <DxColumnFixing :enabled="true" />
                <DxFilterPanel :visible="true" />
                <DxFilterRow :visible="true" />
                <DxHeaderFilter :visible="true" />
                <DxSearchPanel :visible="true" placeholder="Search..." />
                <DxLoadPanel :enabled="true" />
                <DxPaging :page-size="15" />
                <DxPager :visible="true"
                         :allowed-page-sizes="100"
                         :display-mode="full"
                         :show-page-size-selector="true"
                         :show-info="true"
                         :show-navigation-buttons="true" />
                <DxSorting mode="multiple" />
                <DxGroupPanel :visible="true" />
                <DxStateStoring :enabled="false"
                                type="localStorage"
                                storage-key="topicLinkTypeList" />
                <DxExport :enabled="true" :allow-export-selected-data="true" />


                <DxColumn caption='ID' data-type="number" data-field='TltId' :allow-editing="false" :width="100" />
                <DxColumn :caption='col.WorName' data-type='string' data-field='WorName' :allow-editing="false" />
                <DxColumn :caption='col.TtyName1' data-type='string' data-field='TtyName1' :allow-editing="false" />
                <DxColumn :caption='col.TtyName2' data-type='string' data-field='TtyName2' :allow-editing="false" />
                <DxColumn :caption='col.TltName' data-type='string' data-field='TltName' :allow-editing="true">
                    <DxRequiredRule />
                </DxColumn>
                <DxColumn :caption='col.TltCreateButtonText1' data-type='string' data-field='TltCreateButtonText' :allow-editing="true" />
                <DxColumn :caption='col.TltCreateButtonText2' data-type='string' data-field='TltCreateButtonText2' :allow-editing="true" />

                <DxColumn :caption='col.TltCaptionDirection1' data-type='string' data-field='TltCaptionDirection1' :allow-editing="true" />
                <DxColumn :caption='col.TltCaptionDirection2' data-type='string' data-field='TltCaptionDirection2' :allow-editing="true" />
                <DxColumn :caption='col.TltCaptionRequestDirection1' data-type='string' data-field='TltCaptionRequestDirection1' :allow-editing="true" />
                <DxColumn :caption='col.TltCaptionRequestDirection2' data-type='string' data-field='TltCaptionRequestDirection2' :allow-editing="true" />


                <DxColumn :caption='col.TltCaptionSubmittedDirection1' data-type='string' data-field='TltCaptionSubmittedDirection1' :allow-editing="true" />
                <DxColumn :caption='col.TltCaptionSubmittedDirection2' data-type='string' data-field='TltCaptionSubmittedDirection2' :allow-editing="true" />
                <DxColumn :caption='col.TltCaptionEvaluationDirection1' data-type='string' data-field='TltCaptionEvaluationDirection1' :allow-editing="true" />
                <DxColumn :caption='col.TltCaptionEvaluationDirection2' data-type='string' data-field='TltCaptionEvaluationDirection2' :allow-editing="true" />
                <DxColumn :caption='col.TltCaptionClosedDirection1' data-type='string' data-field='TltCaptionClosedDirection1' :allow-editing="true" />
                <DxColumn :caption='col.TltCaptionClosedDirection2' data-type='string' data-field='TltCaptionClosedDirection2' :allow-editing="true" />
                <DxColumn :caption='col.TltCategoryName' data-type='string' data-field='TltCategoryName' :allow-editing="true" />

                <DxColumn data-field="TltCategoryLisId" :caption='col.TltCategoryLisId' :allow-editing="true" :visible="true">
                    <DxLookup :data-source="lookupDataSource" display-expr="LisName" value-expr="LisId" />
                </DxColumn>


                <DxColumn :caption='col.TltItemTemplateA1' data-type='string' data-field='TltItemTemplateA1' :allow-editing="true" />
                <DxColumn :caption='col.TltItemTemplateA2' data-type='string' data-field='TltItemTemplateA2' :allow-editing="true" />
                <DxColumn :caption='col.TltMax1' data-type='number' data-field='TltMax1' :allow-editing="true" />
                <DxColumn :caption='col.TltMax2' data-type='number' data-field='TltMax2' :allow-editing="true" />
                <DxColumn :caption='col.TtlShowInMapping' data-type='boolean' data-field='TtlShowInMapping' :allow-editing="true" />
                <DxColumn :caption='col.TltCreatedBy' data-type='string' data-field='TltCreatedBy' :allow-editing="false" :visible="false" :width="100" />
                <DxColumn :caption='col.TltCreatedOn' data-type='date' data-field='TltCreatedOn' :allow-editing="false" :visible="false" :width="100" />
                <DxColumn :caption='col.TltChangedBy' data-type='string' data-field='TltChangedBy' :allow-editing="false" :visible="false" :width="100" />
                <DxColumn :caption='col.TltChangedOn' data-type='date' data-field='TltChangedOn' :allow-editing="false" :visible="false" :width="100" />


            </DxDataGrid>
        </div>
    </div>
</template>
<script>
    import {
        DxDataGrid,
        DxColumnChooser,
        DxColumnFixing,
        DxFilterRow,
        DxHeaderFilter,
        DxSearchPanel,
        DxLoadPanel,
        DxSorting,
        DxPaging,
        DxPager,
        DxLookup,
        DxColumn,
        DxFilterPanel,
        DxStateStoring,
        DxGroupPanel,
        DxExport,
        DxRequiredRule,
        DxEditing
    } from 'devextreme-vue/data-grid'
    import $ from "jquery"
    import axios from 'axios'
    import { alert } from "devextreme/ui/dialog"

    import { exportDataGrid } from 'devextreme/excel_exporter';
    import { Workbook } from 'exceljs';
    import saveAs from 'file-saver';

    import CustomStore from 'devextreme/data/custom_store';

    const listUri = "WebApi.asmx/api/listService";

    const lookupDataSource = {
        store: new CustomStore({
            key: "LisId",
            loadMode: "raw",
            load: () => {
                return axios
                    .get(listUri + '/GetList')
                    .then(res => {
                        if (res.data.success == true) {
                            return res.data.data;
                        }
                        else {
                            alert(res.data.errorMessage);
                            return [];
                        }
                    });
            }
        }),
        sort: "LisName"
    };

    export default {
        name: 'TopicOverview',
        components: {
            DxDataGrid,
            DxColumnChooser,
            DxColumnFixing,
            DxFilterRow,
            DxHeaderFilter,
            DxRequiredRule,
            DxSearchPanel,
            DxLoadPanel,
            DxSorting,
            DxPaging,
            DxPager,
            DxFilterPanel,
            DxStateStoring,
            DxColumn,
            DxLookup,
            DxGroupPanel,
            DxExport,
            DxEditing,
        },

        data() {
            return {
                lookupDataSource,
                col: {
                    WorName: this.$LanguageProvider.GetResource("WorName", "Caption", "Workflow"),
                    TltName: this.$LanguageProvider.GetResource("TltName", "Caption", "Name"),
                    TtyName1: this.$LanguageProvider.GetResource("TtyName1", "Caption", "Type 1"),
                    TtyName2: this.$LanguageProvider.GetResource("TtyName2", "Caption", "Type 2"),
                    TltCreateButtonText1: this.$LanguageProvider.GetResource("TltCreateButtonText", "Caption", "Create Button Text 1"),
                    TltCreateButtonText2: this.$LanguageProvider.GetResource("TltCreateButtonText2", "Caption", "Create Button Text 2"),
                    TltCaptionDirection1: this.$LanguageProvider.GetResource("TltCaptionDirection1", "Caption", "Caption 1"),
                    TltCaptionDirection2: this.$LanguageProvider.GetResource("TltCaptionDirection2", "Caption", "Caption 2"),

                    TltCaptionSubmittedDirection1: this.$LanguageProvider.GetResource("TltCaptionSubmittedDirection1", "Caption", "Submitted Caption 1"),
                    TltCaptionSubmittedDirection2: this.$LanguageProvider.GetResource("TltCaptionSubmittedDirection2", "Caption", "Submitted Caption 2"),
                    TltCaptionEvaluationDirection1: this.$LanguageProvider.GetResource("TltCaptionEvaluationDirection1", "Caption", "Evaluation Caption 1"),
                    TltCaptionEvaluationDirection2: this.$LanguageProvider.GetResource("TltCaptionEvaluationDirection2", "Caption", "Evaluation Caption 2"),
                    TltCaptionClosedDirection1: this.$LanguageProvider.GetResource("TltCaptionClosedDirection1", "Caption", "Closed Caption 1"),
                    TltCaptionClosedDirection2: this.$LanguageProvider.GetResource("TltCaptionClosedDirection2", "Caption", "Closed Caption 2"),
                    TltCategoryName: this.$LanguageProvider.GetResource("TltCategoryName", "Caption", "Category Caption"),

                    TltCategoryLisId: this.$LanguageProvider.GetResource("TltCategoryLisId", "Caption", "Category List"),

                    TltItemTemplateA1: this.$LanguageProvider.GetResource("TltItemTemplateA1", "Caption", "Template A1"),
                    TltItemTemplateA2: this.$LanguageProvider.GetResource("TltItemTemplateA2", "Caption", "Template A2"),
                    TltMax1: this.$LanguageProvider.GetResource("TltMax1", "Caption", "Max 1"),
                    TltMax2: this.$LanguageProvider.GetResource("TltMax2", "Caption", "Max 2"),
                    TtlShowInMapping: this.$LanguageProvider.GetResource("TtlShowInMapping", "Caption", "Show in Mapping"),
                    TltCreatedBy: this.$LanguageProvider.GetResource("TltCreatedBy", "Caption", "Created By"),
                    TltCreatedOn: this.$LanguageProvider.GetResource("TltCreatedOn", "Caption", "Created On"),
                    TltChangedBy: this.$LanguageProvider.GetResource("TltChangedBy", "Caption", "Changed By"),
                    TltChangedOn: this.$LanguageProvider.GetResource("TltChangedOn", "Caption", "Changed On"),
                }

            }
        },
        computed: {
            topicLinkTypeList() {
                var result = this.$store.state.topicLinkTypeStore.topicLinkTypeList
                return result
            },
        },
        watch: {
        },
        mounted: function () {
            Promise.all([
                this.$store.dispatch("getTopicLinkTypeList", {}),
            ])
        },
        methods: {
            onExporting(e) {
                e.component.beginUpdate();
                const workbook = new Workbook();
                const worksheet = workbook.addWorksheet('Data');
                exportDataGrid({
                    component: e.component,
                    worksheet: worksheet
                }).then(function () {
                    workbook.xlsx.writeBuffer().then(function (buffer) {
                        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Data.xlsx');
                    });
                }).then(function () {
                    e.component.endUpdate();
                });
            },
            onSaving(e) {
                var updates = e.changes.filter(m => m.type == "update").map(m => {
                    return $.extend(m.key, m.data)
                })
                var remove = e.changes.filter(m => m.type == "remove").map(m => m.key.LisId)
                var insert = e.changes.filter(m => m.type == "insert").map(m => {
                    m.data.key = m.key
                    return m.data
                })
                this.$store.dispatch("saveTopicLinkTypeList", { updates: updates, remove: remove, insert: insert })

            }
        }
    }
</script>
<style scoped>
</style>